import summaryCommonStore from "@/store/summaryCommon.store";
import { useEffect, useRef, useState } from "react";
import summarySrcStore from "@/store/summarySrc.store";
import summaryStore from "@/store/summary.store";
import DocItem from "./DocItem";
import recordStore from "@/store/record.store";
import RecordHelper from "@/bussiness/RecordHelper";
import { moveCursorToElementStart, placeCaretAtEnd } from "@/utils/range";
import { formatOldDetail } from "@/utils/formatOldDetail";
import { useShallow } from "zustand/react/shallow";
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  List,
} from "react-virtualized";
import { throttle } from "lodash";
import SearchBar from "@/component/SearchBar";
import SearchIcon from "@/assets/summary/ic_search.svg?react";
import ReactDOM from "react-dom";
import fridayReporter from "@/utils/friday";
import BackTrackSearchBar from "./BackTrackSearchBar";
import { debounce } from "@common/utils";
import { SRC_CONTENT_CLASSNAME } from "@/constants/record";
import useOriginTextFollow from "@/sections/Summary/useOriginTextFollow";
import avPlayerStore from "@/store/avPlayer.store";

// let fetchBackTrackDataTimeout: NodeJS.Timeout | null = null;
interface DocCompleteProps {
  isExpan: boolean;
  setIsExpan: (isExpan: boolean) => void;
}

export default function DocComplete({ isExpan, setIsExpan }: DocCompleteProps) {
  const records = recordStore((state) => state.records);
  const list = records;
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const listComRef = useRef<List>(null);
  const [searching, setSearching] = useState(false);
  const showBackTrace = summaryCommonStore((state) => state.showBackTrace);
  const shareInfo = summaryCommonStore((state) => state.shareInfo);
  const playingPi = avPlayerStore((state) => state.playingPi);
  const lastPIndex = useRef(-1);
  const timer = useRef<NodeJS.Timeout | null>();

  const { jumpToIndex, onRowsRendered } = useOriginTextFollow({records: list, scrollContainerRef, virtualListComRef: listComRef});


  useEffect(() => {
    if (showBackTrace) {
      setSearching(false);
    }
  }, [showBackTrace]);

  const cache = useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 100,
      defaultWidth: 100,
    })
  );

  const { recordEditing, detailInfo } = summarySrcStore(
    useShallow((state) => ({
      recordEditing: state.recordEditing,
      detailInfo: state.detailInfo,
    }))
  );

  const { getAvatar } = summaryCommonStore.getState();

  const operatedInfo = recordStore((state) => state.operatedInfo);

  const handleFocusOperate = (wi: string) => {
    const span = document.querySelector(`[data-word-id="${wi}"]`);
    if (span) {
      moveCursorToElementStart(span);
    }
  };

  const handleFocusPara = (pi: string) => {
    const p = document.querySelector(`[data-p-id="${pi}"]`);
    if (p) {
      placeCaretAtEnd(p);
    }
  };
  const debounceFetchBackTraceData = debounce(() => {
    summaryCommonStore.getState().fetchBackTraceData(false);
  }, 200);

  const debounceHandleClearCache = debounce(() => {
    console.log("handleClearCache", list.length);
    cache.current.clearAll();
    listComRef.current?.recomputeRowHeights();
    listComRef.current?.forceUpdate();
  }, 200);

  // const { summaryLoading, summaryStreamsAllDone } = summaryStore.getState();

  useEffect(() => {
    const unsubscribe = summaryStore.subscribe((state) => [state.summaryLoading, state.summaryStreamsAllDone], (next) => {
      const [summaryLoading, summaryStreamsAllDone] = next;
      if (summaryLoading || summaryStreamsAllDone) {
        if (timer.current != null) {
          console.log('已经在轮询，返回');
          return;
        }
        console.log(`开始轮询：summaryLoading = ${summaryLoading} summaryStreamsAllDone=${summaryStreamsAllDone}`);
        timer.current && clearTimeout(timer.current);
        timer.current = setTimeout(() => {
          debounceFetchBackTraceData();
        }, 500);
        return;
      }
    }, {
      equalityFn: (state, nextState) => {
        return state[0] === nextState[0] && state[1] === nextState[1]
      }
    })

    return () => {
      unsubscribe();
      timer.current && clearTimeout(timer.current);
      timer.current = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 总结完成才开始轮询观点回溯
  // useEffect(() => {
  //   function backTrach() {
  //     console.log('fetchBackTrackDataTimeout == ', fetchBackTrackDataTimeout);
  //     if (fetchBackTrackDataTimeout != null) {
  //       console.log('已经在轮询，返回');
  //       return;
  //     }
  //     if (summaryLoading || summaryStreamsAllDone) {
  //       console.log(`开始轮询：summaryLoading = ${summaryLoading} summaryStreamsAllDone=${summaryStreamsAllDone}`);
  //       fetchBackTrackDataTimeout && clearTimeout(fetchBackTrackDataTimeout);
  //       fetchBackTrackDataTimeout = setTimeout(() => {
  //         debounceFetchBackTraceData();
  //       }, 500);
  //       return;
  //     }
  //     console.log('状态不对，返回');
  //   }
  //   backTrach();
  //   return () => {
  //     console.log('清空定时器');
  //     fetchBackTrackDataTimeout && clearTimeout(fetchBackTrackDataTimeout);
  //     fetchBackTrackDataTimeout = null;
  //   };
  // }, [summaryLoading, summaryStreamsAllDone]);

  // 退出编辑后（无论取消或者完成），需要重新计算虚拟列表
  useEffect(() => {
    if (!recordEditing && lastPIndex.current >= 0) {
      // console.log('退出编辑恢复段落', lastPIndex.current);
      handleRecomputeAfterRowHeights(lastPIndex.current);
    } else if (recordEditing) {
      lastPIndex.current = -1;
    }
  }, [recordEditing]);
  useEffect(() => {
    if (detailInfo?.srcDoc?.pg) {
      const data = formatOldDetail(detailInfo.srcDoc.pg, detailInfo.originType);
      recordStore.getState().setRecords(data);
      RecordHelper.setRecentSpeakersFromDetail(data);
      debounceHandleClearCache();
    }

  }, [detailInfo?.srcDoc?.pg]);

  useEffect(() => {
    setTimeout(() => {
      if (operatedInfo.wi) {
        handleFocusOperate(operatedInfo.wi);
      } else if (operatedInfo.pi) {
        handleFocusPara(operatedInfo.pi);
      }
    }, 0);
  }, [operatedInfo]);

  useEffect(() => {
    const resizeHandler = throttle(() => {
      cache.current.clearAll();
      listComRef.current?.forceUpdate();
    }, 100);
    const observer = new ResizeObserver(resizeHandler);
    observer.observe(scrollContainerRef.current!);
    return () => {
      observer.disconnect();
    };
  }, []);

  const enterSearchMode = () => {
    setSearching(true);
    summaryCommonStore.getState().setShowBackTrace(false);
    fridayReporter.pushData({
      eventCode: "SummaryPage_Text_Search",
    });
  };

  const buildSearch = () => {
    const summarySearch = document.getElementById("summary-search");
    if (!summarySearch) return;
    return ReactDOM.createPortal(
      searching ? (
        <SearchBar
          className="bg-#fff"
          querySelector={`.${SRC_CONTENT_CLASSNAME}`}
          onCancel={() => {
            setSearching(false);
          }}
          trigger="input"
          onSearch={() => {
            summaryCommonStore.getState().setIsScrolled(true);
            if (isExpan) {
              return;
            }
            setIsExpan(true);
            // 需要重渲染
            handleClearCache();
          }}
          onJumpTo={jumpToIndex}
        />
      ) : (
        <SearchIcon
          className={`size-4 cursor-pointer ${detailInfo?.completeDocFinish ? "" : "opacity-30"
            }`}
          onClick={enterSearchMode}
        />
      ),
      summarySearch
    );
  };

  const buildBackTrackSearch = () => {
    const backTraceSearch = document.getElementById("back-track-search");
    if (!backTraceSearch) return;
    return ReactDOM.createPortal(
      <BackTrackSearchBar
        className="bg-#fff"
        querySelector={`.${SRC_CONTENT_CLASSNAME}`}
        onCancel={() => {
          summaryCommonStore.getState().setShowBackTrace(false);
        }}
        onSearch={() => {
          summaryCommonStore.getState().setIsScrolled(true);
          if (isExpan) {
            return;
          }
          setIsExpan(true);
          // 需要重渲染
          handleClearCache();
        }}
        onJumpTo={jumpToIndex}
      />,
      backTraceSearch
    );
  };


  // 更新该行高度
  const recomputeRowHeights = (index: number) => {
    lastPIndex.current = lastPIndex.current >= 0 ? Math.min(lastPIndex.current, index) : index;
    cache.current.clear(index, 0);
    listComRef.current?.recomputeRowHeights(index);
  };
  const handleClearCache = () => {
    cache.current.clearAll();
    listComRef.current?.forceUpdate();
  };

  const handleRecomputeAfterRowHeights = (pIndex?: number) => {
    // 最后一页数据更新段落高度时, 需要记住上一个滚动高度，以便之后恢复滚动条高度
    const scrollTop = listComRef.current?.Grid?.state.scrollTop;
    setTimeout(() => {
      if (pIndex === undefined) return;
      let index = pIndex;
      // 重新计算目标段落以及后面段落的高度，不能重新计算所有，会导致滚动条跳动
      while (index <= list.length) {
        recomputeRowHeights(index);
        index++;
      }
      if (scrollTop !== undefined) {
        listComRef.current?.Grid?.scrollToPosition({
          scrollLeft: 0,
          scrollTop,
        });
      }
    }, 0);
  };


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const rowRenderer = ({ index, key, style }: any) => {
    return (
      <CellMeasurer
        cache={cache.current}
        columnIndex={0}
        key={key}
        parent={listComRef.current!} // List组件的引用
        rowIndex={index}
      >
        <div style={style}>
          <DocItem
            key={list[index].pi + index}
            isEditing={recordEditing}
            isPlaying={playingPi === list[index].pi}
            underlineOnFocus={true}
            record={list[index]}
            avatarSrc={getAvatar(list[index].roleName)}
            recomputeRowHeights={() => recomputeRowHeights(index)}
            onMerge={handleRecomputeAfterRowHeights}
            onSplit={handleRecomputeAfterRowHeights}
            editable={!shareInfo}
          />
        </div>
      </CellMeasurer>
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderList = ({ height, width }: any) => {
    return (
      <List
        noRowsRenderer={() => (
          <div className="text-3.5 color-#A1A7B2">此处空寂无声～</div>
        )}
        className="my-scrollbar pr-1.5"
        ref={listComRef}
        height={height || 100}
        rowCount={list.length}
        rowHeight={cache.current.rowHeight}
        deferredMeasurementCache={cache.current}
        rowRenderer={rowRenderer}
        width={width || 100}
        onRowsRendered={onRowsRendered}
      />
    );
  };

  return (
    <div className="w-full h-full" ref={scrollContainerRef}>
      <AutoSizer>{renderList}</AutoSizer>
      {buildSearch()}
      {showBackTrace && buildBackTrackSearch()}
    </div>
  );
}
